import { FormProvider } from 'react-hook-form';
import { Outlet } from 'react-router-dom';
import styles from './VisitNoteTemplateLayout.module.css';
import { useVisitNoteSubmit } from './hooks/useVisitNoteSubmit';
import { useVisitNoteTemplate } from './hooks/useVisitNoteTemplate';

export const VisitNoteTemplateLayout = () => {
  const { methods } = useVisitNoteTemplate();
  const { onSubmit, onError } = useVisitNoteSubmit();

  return (
    <FormProvider {...methods}>
      <form
        aria-label="Visit Note Template Form"
        onSubmit={methods.handleSubmit(onSubmit, onError)}
        className={styles.container}
      >
        <Outlet />
      </form>
    </FormProvider>
  );
};
